import { useGetFeatureFlags } from 'api';
import type { FeatureFlag } from 'api';

export type FeatureName = keyof FeatureFlag;
export const useFeatures = () => {
  const {
    data: featureFlags = {} as FeatureFlag,
    isLoading,
    isError,
    isSuccess
  } = useGetFeatureFlags<FeatureFlag>({ query: { select: (r) => r.data } });

  const getFeatureFlag = (key: FeatureName) => featureFlags?.[key];

  return { getFeatureFlag, isLoading, isError, isSuccess };
};
